// InviteWelcome.jsx
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

const InviteWelcome = ({ _api_fast_qr, userDetails, signInErrorMessage }) => {
  const { token } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  // Kick off fast QR sign-in on mount
  useEffect(() => {
    if (!token) return;
    setLoading(true);
    // Call your API wrapper (pass userEmail just to satisfy your setter)
    _api_fast_qr({ token });
  }, [token, _api_fast_qr]);

  // Redirect once logged in (either via userDetails or saved token)
  useEffect(() => {
    const saved = localStorage.getItem("loggined_token");
    if ((userDetails && userDetails.user_loged_in) || (saved && saved.length > 0)) {
      setLoading(false);
      history.replace("/Dashboard");
    }
  }, [userDetails, history]);

  // Stop loading if an error message appears
  useEffect(() => {
    if (signInErrorMessage && signInErrorMessage.length > 0) {
      setLoading(false);
    }
  }, [signInErrorMessage]);

  return (
    <div style={{ padding: 24, fontSize: 18 }}>
      <div style={{ marginBottom: 8 }}>Welcome {token}</div>
      {loading && <div>Signing you in…</div>}
      {signInErrorMessage && (
        <div style={{ color: "tomato", marginTop: 8 }}>{signInErrorMessage}</div>
      )}
    </div>
  );
};

export default InviteWelcome;
